import { DOWNLOAD_WORKER_REPORT_EXCEL_FAILURE, DOWNLOAD_WORKER_REPORT_EXCEL_REQUEST, DOWNLOAD_WORKER_REPORT_EXCEL_SUCCESS, WorkerReportExcelActionTypes, WorkerReportExcelState } from 'store/reducers/types/workerReport/workerReportExcel';

const defaultState: WorkerReportExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function workerReportExcel(state = defaultState, action: WorkerReportExcelActionTypes): WorkerReportExcelState {
  switch (action.type) {
    case DOWNLOAD_WORKER_REPORT_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_WORKER_REPORT_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_WORKER_REPORT_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};